import { apiCall, type ApiClientConfig } from "@playbookai/api-clients";

export interface KpiLinkedVsm {
  readonly vsmId: string;
  readonly vsmName: string;
}

export const vsmKpiLinksApi = {
  listForKpi(
    config: ApiClientConfig,
    kpiId: string,
  ): Promise<readonly KpiLinkedVsm[]> {
    return apiCall(
      config,
      "GET",
      `/v1/vsms/by-kpi/${encodeURIComponent(kpiId)}`,
    );
  },
};
